export const DepositPaymentStatusEnum = {
  Draft: 'Draft',
  Processing: 'Processing',
  Rejected: 'Rejected',
  Completed: 'Completed',
  Failed: 'Failed',
  Cancelled: 'Cancelled',
  Returned: 'Returned',
} as const;
export type DepositPaymentStatusEnum = (typeof DepositPaymentStatusEnum)[keyof typeof DepositPaymentStatusEnum];
